var React = require('react');

function Rotate (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M107.75,40C96.07,29.9,86.63,17,70.23,13.09,46.07,7.33,21,21.26,13.71,45a47.35,47.35,0,0,0,88.73,32.73c.45-1.07.78-2.21,1.33-3.23,1.67-3.1,4.37-4.16,7.58-3a5.1,5.1,0,0,1,3.25,6.9A54.27,54.27,0,0,1,110.45,88a59,59,0,0,1-69.09,27.52C14.73,107.4-2,82,.2,53.16,2.22,26.79,23.35,4.43,50.5.65,69-1.94,85.47,3.25,99.35,16c5.88,5.37,11.63,10.89,18.24,17.1.24-2.34.49-3.7.5-5.06.07-5.33-.06-10.67.12-16,.13-3.63,2.29-6.69,5.82-5.93,2.41.51,5.94,3.67,6.05,5.78.58,11.8.47,23.65.17,35.47-.1,3.8-3.14,5.79-6.89,5.82-11.33.08-22.65,0-34,0-3.85,0-6.6-1.91-6.58-6s2.76-5.81,6.64-5.84c5.94,0,11.88,0,17.83,0Z"}))));
}

Rotate.defaultProps = {"viewBox":"0 0 130.49 118.18"};

module.exports = Rotate;

Rotate.default = Rotate;
